import { colors, getSpacing } from '@cabonline/ui-shared';
import { Text } from '../text';
import styled from '@emotion/styled';
import { FC } from 'react';
import { LinkRouter } from '../link-router';

const StyledBreadCrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  flex-flow: wrap;
  margin-bottom: ${getSpacing('xs')};
`;

const StyledBreadCrumbItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
`;

interface BreadcrumbPath {
  path?: string;
  name: string;
}

interface BreadcrumbsProps {
  paths: BreadcrumbPath[];
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ paths }) => {
  return (
    <StyledBreadCrumbContainer aria-label="breadcrumb">
      {paths.map((crumb, index) => {
        const { path, name } = crumb;
        const isLast = index === paths.length - 1;
        const isFirst = index === 0;
        return (
          <StyledBreadCrumbItem key={index}>
            {!isFirst && (
              <Text color={colors.gray2} weight="bold">
                /
              </Text>
            )}
            <div aria-label={`breadcrumb-item ${isLast ? 'active' : ''}`}>
              {!path ? (
                <Text weight="extraBold">{name}</Text>
              ) : (
                <LinkRouter to={path} weight="bold" color={colors.gray2}>
                  {name}
                </LinkRouter>
              )}
            </div>
          </StyledBreadCrumbItem>
        );
      })}
    </StyledBreadCrumbContainer>
  );
};
